export enum SimpleGridType {
  Default = 'defaultStyle',
  Grid = 'gridStyle',
}
